import Lista from './Lista';

export const AprovarIndisponibilidadeLista = Lista;
